import './styles.scss'

import { Routing } from '../../routes'

const App = () => <Routing />

export default App
